<template>
  <div>
    <div class="big_top" :class="{ color: color }">
      <div class="header">
        <div class="w">
          <!-- 导航 -->
          <div class="nav_box">
            <div
              class="nav_item"
              v-for="(item, index) in navList"
              :key="index"
              :class="{ activeHearder: activeHearder == index }"
              @click="changeNav(index)"
            >{{ item }}</div>
          </div>

          <div
                  class="msg"
          >
            <div v-if="msgCount > 0">
              <el-badge :value="msgCount" :max="99" class="item">
                <img src="../../assets/img/home/icon_msg.png" alt/>
              </el-badge>
            </div>
            <div v-else>
              <img src="../../assets/img/home/icon_msg.png" alt/>
            </div>
            <div class="msg_body" v-if="msgShow">
              <div class="msg_top">
                <div
                        :class="{ msgActive: msgActive == 0 }"
                        @click="changeMsg(0)"
                >
                  <img
                          v-if="msgActive == 0"
                          src="../../assets/img/home/icon_tongzhi2.png"
                          alt
                  />
                  <img
                          v-else
                          src="../../assets/img/home/icon_tongzhi.png"
                          alt
                  />
                  通知
                </div>
                <div
                        :class="{ msgActive: msgActive == 1 }"
                        @click="changeMsg(1)"
                >
                  <img
                          v-if="msgActive == 1"
                          src="../../assets/img/home/icon_gonggao.png"
                          alt
                  />
                  <img
                          v-else
                          src="../../assets/img/home/icon_gonggao2.png"
                          alt
                  />
                  公告
                </div>
              </div>
              <div class="msg_list" v-if="msgList.length > 0">
                <div
                        class="msg_item"
                        v-for="(item, index) in msgList"
                        :key="index"
                        @mouseenter="msgActive2 = index"
                        @mouseleave="msgActive2 = -1"
                        @click="goMsg(item.id, item.is_real)"
                >
                  <div class="msg_left">
                    <div v-if="item.is_real == 0"></div>
                  </div>
                  <div class="msg_right">
                    <div
                            class="over"
                            :class="{ msgActive: msgActive2 == index }"
                    >
                      <!-- <span>【消息】</span> -->
                      {{ item.title }}
                    </div>
                    <div>{{ (item.create_time * 1000) | dateFormat }}</div>
                  </div>
                </div>
              </div>
              <div v-else class="none">暂无消息</div>
              <div v-if="msgList.length > 0" class="msg_btm" @click="goMsg2">
                全部消息
              </div>
            </div>
          </div>
          <!-- 个人中心 -->
          <div
            :class="{ activeHearder: down }"
            @mouseenter="perBodyShow"
            @mouseleave="perBodyHide"
            class="personal_box"
          >
            <div class="per_top" @click="goPersonal">
              <img v-if="header_img" :src="url + header_img" alt />
              <img v-else src="../../assets/img/home/img3.png" alt />
              个人中心
              <i class="el-icon-caret-bottom el-icon--right"></i>
            </div>
            <div class="per_body" :class="{ per_body2: down2 }">
              <div class="per_body_item" @click="goPersonal">
                <i class="el-icon-user"></i>
                账号管理
              </div>
              <div class="per_body_item" @click="goPersonal(1)">
                <i class="el-icon-bell"></i>
                消息中心
              </div>
              <div class="goOut" @click="goOut">退出</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div v-if="loginPage" class="footer_btm">
      <div>
<!--        版权所有 {{ schoolInfo.name }}-->
<!--        <br />中政网络科技（北京）有限公司 技术支持-->
<!--        <br />河南致远教育科技有限公司 技术支持-->
      </div>
    </div>
    <div v-else class="footer_btm2">
      <div>
        <div>
<!--          版权所有 {{ schoolInfo.name }}-->
<!--          <br />中政网络科技（北京）有限公司 技术支持-->
<!--          <br />河南致远教育科技有限公司 技术支持-->
<!--          <br/>-->
<!--          <a :href="'https://beian.miit.gov.cn/'">-->
<!--            京ICP备16009778号</a>-->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from "store";
import {getMsgList, getMsgDetail} from "../../assets/js/api";
import Bus from "../../bus.js";
export default {
  data() {
    return {
      header_img: "",
      schoolInfo: "",
      loginPage: true,
      activeHearder: 0,
      down: false,
      down2: false,
        navList: ["首页", "课程中心", "考试练习", "成绩查询", "校园论坛", "毕业论文"],
      color: false,
        msgActive: 0,
        msgActive2: -1,
        msgActive3: -1,
        msgShow: false,
        msgList: [],
        msgCount: "",
        currentPage: 1,
        size: 3,
    };
  },
  mounted() {

    // 学校信息
    Bus.$on("schoolInfo", (data) => {
      // console.log(data);
      this.schoolInfo = data;
      store.set("schoolInfo", this.schoolInfo);
    });
    if (store.get("schoolInfo")) {
      this.schoolInfo = store.get("schoolInfo");
    }
    // 用户头像
    Bus.$on("userInfo", (data) => {
      // console.log(data.header_img);
      this.header_img = data.header_img;
      store.set("header_img", this.header_img);
    });
    if (store.get("header_img")) {
      this.header_img = store.get("header_img");
    }
    if (this.$route.path == "/login") {
      this.loginPage = true;
    } else {
      this.loginPage = false;
    }
    window.addEventListener("scroll", this.handleScroll);

    if (window.location.href.indexOf("talk")!=-1) {
        this.activeHearder = 4;
    } else if (window.location.href.indexOf("study")!=-1) {
      this.activeHearder = 1;
    } else if (window.location.href.indexOf("index")!=-1) {
      this.activeHearder = 0;
    }else if (window.location.href.indexOf("test")!=-1) {
        this.activeHearder = 2;
    }else if (window.location.href.indexOf("result")!=-1) {
        this.activeHearder = 3;
    } else if (window.location.href.indexOf("paper") != -1) {
        this.activeHearder = 5;
    }else{
        this.activeHearder = store.get("active");
    }
  },
  methods: {
    // 退出
    goOut() {
      window.localStorage.clear();
      this.$message.success("退出成功");
      this.$router.push("/login");
      window.location.reload();
    },

    goHome() {
      if (this.$route.path !== "/index") {
        this.$router.push("/index");
        store.set("active", 0);
        this.activeHearder = 0;
      }
    },
// 获取消息列表
      getMsgList() {
          getMsgList({
              siteId: window.localStorage.getItem("siteId"),
              type: this.type,
              user_id: JSON.parse(window.localStorage.getItem("userInfo"))
                  ? JSON.parse(window.localStorage.getItem("userInfo")).id
                  : "",
              offset: this.currentPage,
              limit: this.size,
          }).then((res) => {
              if (res.code == 200) {
                  this.msgList = res.data.list;
                  this.msgCount = res.data.count;
              }
          });
      },
      goMsg(id, isReal) {
          if (id) {
              // Bus.$emit("businessId", id,isReal,true);
              getMsgDetail({
                  a_id: id,
              }).then((res) => {
                  if (res.code == 200) {
                      window.sessionStorage.setItem(
                          "detail",
                          JSON.stringify(res.data.info)
                      );
                      window.sessionStorage.setItem("isReal", isReal);
                      window.sessionStorage.setItem("headerMSG", true);
                      if (this.$route.path !== "/personal") {
                          this.$router.push("/personal");
                      }
                      window.localStorage.setItem("perHeader", 4);
                  }
              });
          }
      },
      changeMsg(i) {
          this.msgActive = i;
          this.currentPage = 1;
          this.type = i + 1;
          this.getMsgList();
      },
    changeNav(i) {
      // console.log(i);
      store.set("active", i);
      store.set("current", 0);
      store.set("activeTabs", 0);
      // store.set('down',false)
      this.activeHearder = i;
      if (i == 0) {
        if (this.$route.path !== "/index") {
          this.$router.push("/index");
        }
      } else if (i == 1) {
        if (this.$route.path !== "/study") {
          this.$router.push("/study");
        }
      } else if (i == 4) {

        if (this.$route.path !== "/talk") {
          this.$router.push("/talk");
        }
      } else if (i == 2) {

          if (this.$route.path !== "/test") {
              this.$router.push("/test");
          }
      } else if (i == 3) {

          if (this.$route.path !== "/result") {
              this.$router.push("/result");
          }
      } else if (i == 5) {

          if (this.$route.path !== "/paper") {
              this.$router.push("/paper");
          }
      }

    },
    // 个人中心
    goPersonal(y) {
      this.activeHearder = -1;
      // this.down = true
      // store.set('down',this.down)
      store.set("activeHearder", -1);
      if (this.$route.path == "/personal") {
        return;
      } else {
        store.set("activeTabs", 0);
        if (y == 1) {
          store.set("current", 1);
        }
        this.$router.push("/personal");
      }
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // let offsetTop = document.querySelector(".header").offsetTop;
      //设置背景颜色的透明读
      if (scrollTop) {
        // this.style.backgroundColor = `rgba(2,154,255,${scrollTop / scrollTop})`;
        this.color = true;
      } else if (scrollTop == 0) {
        // this.style.backgroundColor = "transparent";
        this.color = false;
      }
    },
    perBodyShow() {
      this.down = true;
      this.down2 = true;
    },
    perBodyHide() {
      this.down = false;
      this.down2 = false;
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
    changeTit(item) {
        this.selectTit = item;
        this.selectBody = false;
    },
};
</script>
<style lang="less" scoped>
.big_top {
  position: fixed;
  top: 0;
    z-index: 888;
  width: 100%;
}
.activeHearder {
    background: #f25412;
  // opacity: 0.11;
  border-bottom: 2px solid #ffffff;
  margin-bottom: 1px;
}
@deep: ~">>>";
input::-webkit-input-placeholder {
  color: #343434;
  font-size: 16px;
}
@deep: ~">>>";
input::-moz-input-placeholder {
  color: #343434;
  font-size: 16px;
}
@deep: ~">>>";
input::-ms-input-placeholder {
  color: #343434;
  font-size: 16px;
}
.header {
  position: absolute;
    /*top: 100px;*/
  left: 0;
    z-index: 666;
  width: 100%;
  height: 60px;
  text-align: center;
  // line-height: 60px;
  color: #333;
    background-color: #ff6829; //rgba(13, 140, 255, 0.76);
  transition: all linear 0.5s;
  .w {
    display: flex;
    align-items: center;
    width: 1200px;
    margin: 0 auto;
    height: 60px;
    .nav_box {
      display: flex;
      align-items: center;
      height: 60px;
      font-size: 16px;
        color: #ebebf0;
      .nav_item {
        height: 100%;
        line-height: 60px;
        padding: 0 30px;
        box-sizing: border-box;
        cursor: pointer;
      }
    }
    .msg {
      padding-left: 290px;
      position: relative;
      /*margin-right: 50px;*/
      img {
        width: 24px;
        height: 27px;
        cursor: pointer;
      }
      .msg_body {
        position: absolute;
        top: 22px;
        left: -140px;
        z-index: 23;
        width: 307px;
        height: 280px;
        background: url("../../assets/img/home/bg_1_5.png");
        background-size: 100%;
        padding: 25px;
        box-sizing: border-box;
        .msg_top {
          display: flex;
          font-size: 14px;
          color: #666;
          height: 30px;
          line-height: 30px;
          border-bottom: 1px solid #f2f2f2;
          img {
            width: 14px;
            height: 14px;
            vertical-align: middle;
          }
          > div {
            width: 50%;
            text-align: center;
            cursor: pointer;
          }
        }
        .msg_list {
          padding: 12px 0;
          box-sizing: border-box;
          .msg_item {
            display: flex;
            margin-bottom: 20px;
            cursor: pointer;
            .msg_left {
              div {
                width: 6px;
                height: 6px;
                background: #f13232;
                border-radius: 50%;
                margin-top: 5px;
                // margin-right: 8px;
              }
            }
            .msg_right {
              width: 95%;
              font-size: 12px;
              // color: #0090f0;
              > div {
                width: 100%;
              }
              > div:nth-child(2) {
                color: #999;
                // margin-left: 8px;
                margin-top: 5px;
              }
              span {
                color: #333333;
              }
            }
          }
          .msg_item:last-child {
            margin-bottom: 0;
          }
        }
        .msg_btm {
          border-top: 1px solid #f2f2f2;
          width: 100%;
          height: 38px;
          font-size: 12px;
          text-align: center;
          line-height: 38px;
          cursor: pointer;
        }
      }
    }
    .personal_box {
      position: relative;
      width: 140px;
      height: 100%;
      line-height: 60px;
      text-align: center;
      margin-left: 30px;
      padding-left: 10px;
      box-sizing: border-box;
      .per_top {
        display: flex;
        align-items: center;
        line-height: 60px;
        cursor: pointer;
        color: #fff;
        font-size: 16px;
        img {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          margin-right: 10px;
        }
      }
      .per_body {
        display: none;
        position: absolute;
        bottom: -148px;
        left: 0;
        width: 100%;
        height: 148px;
        text-align: left;
        padding: 12px;
        box-sizing: border-box;
        background-color: #fff;
        line-height: 2;
        font-size: 14px;
        color: #343434;
        border-radius: 0 0 5px 5px;
        transition: all linear 0.5s;
        .per_body_item {
          height: 35px;
          line-height: 35px;
          font-size: 14px;
          cursor: pointer;
          .el-icon-user:before,
          .el-icon-bell:before {
            font-size: 20px;
            margin-right: 5px;
            color: #9a9a9a;
          }
        }
        .goOut {
          width: 60px;
          height: 19px;
          line-height: 19px;
          background: #f85415;
          border-radius: 10px;
          font-size: 12px;
          color: #fff;
          text-align: center;
          margin: 0 auto;
          margin-top: 20px;
          cursor: pointer;
        }
      }
      .per_body2 {
        display: block;
        transition: all linear 0.5s;
      }
    }
  }
}
.color {
  // color: #fff;
  top: 0;
}
.w {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header_top {
  width: 100%;
  height: 100px;
  background-color: #f4f4f4;
  .logo {
    img {
      width: 540px;
      height: 67px;
      cursor: pointer;
    }
  }
  .ewm_box {
    display: flex;
    align-items: center;
    font-size: 12px;
    > div:nth-child(1) {
      margin-right: 40px;
    }
    .ewm {
      display: flex;
      align-items: center;
      div {
        // -webkit-writing-mode: vertical-rl;
        // writing-mode: vertical-rl;
        writing-mode: vertical-lr; /*从左向右 从右向左是 writing-mode: vertical-rl;*/
        writing-mode: tb-lr; /*IE浏览器的从左向右 从右向左是 writing-mode: tb-rl；*/
      }
      img {
        width: 70px;
        height: 70px;
        margin-left: 13px;
      }
    }
  }
}
.footer_btm {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 200px;
  /*line-height: 100px;*/
  text-align: center;
  background-color: #07ff20;
  /*border-top: 1px solid #ea130e;*/
  font-size: 14px;
  color: #666;
  // padding-top: 20px;
  // box-sizing: border-box;
  > div {
    display: inline-block;
    /*line-height: 30px; !*单独给子元素设置行高，覆盖父级元素的行高*!*/
    vertical-align: middle; /*基线居中对齐*/
  }
}
.footer_btm2 {
  margin-bottom: 10px;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 140px;
  text-align: center;
  // background-color: #029aff;
    border-top: 1px solid #f87400;
  font-size: 14px;
  color: #fff;
  line-height: 130px;
  padding-top: 10px;
  box-sizing: border-box;
  > div {
    height: 130px;
    background-color: #ff6829; //rgba(13, 140, 255, 0.76);
    width: 100%;
    > div {
      display: inline-block;
      line-height: 30px; /*单独给子元素设置行高，覆盖父级元素的行高*/
      vertical-align: middle; /*基线居中对齐*/
    }
  }
}
</style>
